/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncReceiptSettlementExchangeRatePayloadDto
 */
export interface SyncReceiptSettlementExchangeRatePayloadDto {
    /**
     * Original currency
     * @type {string}
     * @memberof SyncReceiptSettlementExchangeRatePayloadDto
     */
    originalCurrency: string;
    /**
     * 
     * @type {string}
     * @memberof SyncReceiptSettlementExchangeRatePayloadDto
     */
    settlementExchangeRate: string;
}

/**
 * Check if a given object implements the SyncReceiptSettlementExchangeRatePayloadDto interface.
 */
export function instanceOfSyncReceiptSettlementExchangeRatePayloadDto(value: object): value is SyncReceiptSettlementExchangeRatePayloadDto {
    if (!('originalCurrency' in value) || value['originalCurrency'] === undefined) return false;
    if (!('settlementExchangeRate' in value) || value['settlementExchangeRate'] === undefined) return false;
    return true;
}

export function SyncReceiptSettlementExchangeRatePayloadDtoFromJSON(json: any): SyncReceiptSettlementExchangeRatePayloadDto {
    return SyncReceiptSettlementExchangeRatePayloadDtoFromJSONTyped(json, false);
}

export function SyncReceiptSettlementExchangeRatePayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncReceiptSettlementExchangeRatePayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'originalCurrency': json['originalCurrency'],
        'settlementExchangeRate': json['settlementExchangeRate'],
    };
}

export function SyncReceiptSettlementExchangeRatePayloadDtoToJSON(json: any): SyncReceiptSettlementExchangeRatePayloadDto {
    return SyncReceiptSettlementExchangeRatePayloadDtoToJSONTyped(json, false);
}

export function SyncReceiptSettlementExchangeRatePayloadDtoToJSONTyped(value?: SyncReceiptSettlementExchangeRatePayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'originalCurrency': value['originalCurrency'],
        'settlementExchangeRate': value['settlementExchangeRate'],
    };
}

